import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { HeroOrbit } from './HeroOrbit';
import { TradingViewWidget } from './TradingViewWidget';
const EARTH_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/5b86738c-2ad3-46cf-a400-a754cde08084.jpg';
const CHART_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  details: false,
  hide_side_toolbar: true,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: false,
  hotlist: false,
  interval: 'D',
  locale: 'es',
  save_image: true,
  style: '1',
  symbol: 'OANDA:XAUUSD',
  theme: 'dark',
  timezone: 'America/New_York',
  backgroundColor: '#0F0F0F',
  gridColor: 'rgba(242, 242, 242, 0.2)',
  watchlist: [],
  withdateranges: false,
  compareSymbols: [],
  support_host: 'https://www.tradingview.com',
  studies: [],
  autosize: true
};
export function Hero() {
  const reduced = useReducedMotion();
  const fade = (delay: number) => reduced ? {} : {
    initial: {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  };
  return <section id="top" className="relative isolate overflow-hidden bg-brand-950" data-id="element-114" data-mp="39authk0ozz0e">
      <img src={EARTH_IMAGE} alt="" aria-hidden="true" className="absolute inset-x-0 top-[30%] -z-10 h-[70%] w-full object-cover object-top opacity-60" data-id="element-115" data-mp="3e960lmzlrvex" />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,#1B3BF0_0%,#101F8C_30%,rgba(6,13,61,0.75)_60%,#060D3D_100%)]" data-id="element-116" data-mp="358reiletecad" />

      <div className="mx-auto max-w-4xl px-5 pt-28 text-center sm:pt-40" data-id="element-117" data-mp="2qhqurk8mavyx">
        <motion.p {...fade(0)} className="text-[10.5px] font-semibold uppercase tracking-overline text-brand-200 sm:text-[11px]" data-id="element-118" data-mp="2vjpvsngvxgsp">
          Trading • Markets • Opportunities
        </motion.p>

        <motion.h1 {...fade(0.05)} className="mt-5 text-[2.35rem] font-semibold leading-[1.02] tracking-[-0.035em] text-white sm:text-[3.75rem] lg:text-[4.6rem]" data-id="element-119" data-mp="2lmv00cbzxui4">
          Tu próximo paso en el mercado comienza aquí.
        </motion.h1>

        <motion.p {...fade(0.1)} className="mx-auto mt-6 max-w-2xl text-[15.5px] leading-relaxed text-white/75 sm:text-[18px]" data-id="element-120" data-mp="id02aln7dwm0">
          Descubre una experiencia de trading moderna y accede a una plataforma
          diseñada para traders que buscan explorar los mercados financieros con
          herramientas digitales y una experiencia profesional.
        </motion.p>

        <motion.div {...fade(0.16)} className="mx-auto mt-9 flex max-w-sm flex-col gap-3 sm:max-w-none sm:flex-row sm:justify-center" data-id="element-121" data-mp="111err4hvh2kp">
          <CTAButton label="Abrir mi cuenta" location="hero_primary" size="lg" variant="white" data-id="element-122" data-mp="3ltglflt1eim8" />
          <CTAButton label="Conocer la plataforma" location="hero_secondary" variant="onDark" size="lg" withIcon={false} data-id="element-123" data-mp="3hrlosum1wtes" />
        </motion.div>

        <motion.p {...fade(0.22)} className="mt-6 text-[12px] font-medium text-white/60" data-id="element-124" data-mp="21a4t5ua36g5g">
          Registro online • Acceso a la plataforma • Trading con riesgo
        </motion.p>
        <motion.p {...fade(0.26)} className="mt-2 text-[12px] text-white/45" data-id="element-125" data-mp="2b1r9g51a75f2">
          El trading implica riesgos y puede no ser adecuado para todos los
          inversores.
        </motion.p>
      </div>

      <div className="mt-10 sm:mt-14" data-id="element-126" data-mp="2kxkk1ivfwou7">
        <HeroOrbit data-id="element-127" data-mp="2l0qbv5vge4tm" />
      </div>

      <motion.div initial={reduced ? undefined : {
      opacity: 0,
      y: 24
    }} animate={reduced ? undefined : {
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative z-10 mx-auto -mt-8 max-w-5xl px-3 pb-14 sm:-mt-16 sm:px-5 sm:pb-20" data-id="element-128" data-mp="2ozz05v7q5ahs">
        <div className="rounded-2xl border border-white/12 bg-white/[0.06] p-1.5 shadow-[0_40px_90px_-40px_rgba(0,0,0,0.9)] backdrop-blur-md sm:p-2" data-id="element-129" data-mp="zmc2c8fcyx68">
          <div className="h-[360px] overflow-hidden rounded-xl bg-[#0F0F0F] sm:h-[520px]" data-id="element-130" data-mp="3vhp3brhz62nc">
            <TradingViewWidget config={CHART_CONFIG} copyrightSymbol="XAUUSD" copyrightHref="https://www.tradingview.com/symbols/XAUUSD/?exchange=OANDA" data-id="element-131" data-mp="3vk1hdtkm3sv4" />
          </div>
        </div>
      </motion.div>
    </section>;
}